import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import MsCorrect from './ms.correct';
import MsIncorrect from './ms.incorrect';
import { appendScript } from '../../../../utils/appendScript';

import { compose } from 'redux';
import FeedbackLayout from '../../utils/feedback/feedbackLayout';

const mapStateToProps = (state) => {
	const {
		rightFeedbackProps,
		answerCount,
		leftFeedbackProps,
	} = state.rootReducer.testPageDetails;

	return {
		rightFeedbackProps,
		answerCount,
		leftFeedbackProps,
	};
};

const MsFeedback = ({ rightFeedbackProps: { score, defaultFeedback } }) => {
	useEffect(() => {
		appendScript('testMS');
	}, []);

	return (
		<>
			<section className="quiz-area-options ">
				{score === 1 ? (
					<MsCorrect />
				) : score === 0 ? (
					<MsIncorrect />
				) : (
					<MsCorrect />
				)}
				<input type="hidden" name="choosen-answer" className="choosen-answer" />
			</section>

			{!!defaultFeedback && (
				<div class="tutor-feedback">
					<i class="fa fa-comments-o" aria-hidden="true"></i>
					<p>
						<span>Feedback</span>
						{defaultFeedback}
					</p>
				</div>
			)}
		</>
	);
};
export default compose(
	FeedbackLayout,
	connect(mapStateToProps, null),
)(MsFeedback);
